import { NgModule } from '@angular/core';

import { LIB_CommonModule } from "pbc.angular";

import { ObjektService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [
    ObjektService,
  ],
  exports: []
})
export class ObjektServiceModule { }
